import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

const QueryKey = {
	DirectReports: 'direct-reports',
};

interface DirectReportsResponse {
	users: {
		id: string;
	}[];
}

export const useFetchDirectReports = () => {
	const http = useHttpClient('v2');
	return useQuery(
		[QueryKey.DirectReports],
		() => {
			return http.get<DirectReportsResponse>('team_members_tracker');
		},
		{
			select: (data) => data.data.users,
			retry: false,
		}
	);
};
